import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "SyncWithVikash - Flutter & iOS Developer | Vikash Kumar Sharma",
  description = "Professional Flutter & iOS developer with 11+ published apps. Specializing in healthcare, education, enterprise & e-commerce mobile applications. Expert in Provider, REST APIs, Firebase, and Razorpay integration.",
  keywords = "Flutter developer, iOS developer, mobile app developer, React Native, Vikash Kumar Sharma, SyncWithVikash, app development, healthcare apps, e-commerce apps, Clubera, HMPK, MediVault",
  ogImage = "https://syncwithvikash.me/og-image.png",
  url = "https://syncwithvikash.me"
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Vikash Kumar Sharma" />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="SyncWithVikash" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="format-detection" content="telephone=yes" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      
      {/* Geo Tags */}
      <meta name="geo.region" content="IN-UP" />
      <meta name="geo.placename" content="Gautam Buddha Nagar" />
      <meta name="geo.position" content="28.5355;77.3910" />
      
      {/* Mobile */}
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      <meta name="apple-mobile-web-app-title" content="SyncWithVikash" />
      
      {/* JSON-LD Schema for better SEO */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Person",
          "name": "Vikash Kumar Sharma",
          "alternateName": "SyncWithVikash",
          "url": url,
          "image": ogImage,
          "jobTitle": "Flutter & iOS Developer",
          "worksFor": {
            "@type": "Organization",
            "name": "SyncWithVikash"
          },
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Gautam Buddha Nagar",
            "addressRegion": "Uttar Pradesh",
            "postalCode": "203202",
            "addressCountry": "IN"
          },
          "email": "kumarvikash010203@gmail.com",
          "telephone": "+91-9639631382",
          "sameAs": [
            "https://www.linkedin.com/in/vikash-kumar-sharma-35482a104",
            "http://syncwithvikash.me/"
          ],
          "knowsAbout": [
            "Flutter Development",
            "iOS Development", 
            "Mobile App Development",
            "React Native",
            "Firebase",
            "REST APIs"
          ]
        })}
      </script>
      
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          "name": "SyncWithVikash",
          "description": description,
          "url": url,
          "telephone": "+91-9639631382",
          "email": "kumarvikash010203@gmail.com",
          "priceRange": "$$",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Gautam Buddha Nagar",
            "addressRegion": "Uttar Pradesh",
            "addressCountry": "IN"
          },
          "areaServed": {
            "@type": "Country",
            "name": "India"
          },
          "serviceType": [
            "Mobile App Development",
            "Flutter Development",
            "iOS Development",
            "Backend Development"
          ]
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
